var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.0002C14.3417 10.0002 15.8334 8.5085 15.8334 6.66683C15.8334 4.82516 14.3417 3.3335 12.5 3.3335C10.6584 3.3335 9.16671 4.82516 9.16671 6.66683C9.16671 8.5085 10.6584 10.0002 12.5 10.0002ZM5.00004 8.3335V5.8335H3.33337V8.3335H0.833374V10.0002H3.33337V12.5002H5.00004V10.0002H7.50004V8.3335H5.00004ZM12.5 11.6668C10.275 11.6668 5.83337 12.7835 5.83337 15.0002V16.6668H19.1667V15.0002C19.1667 12.7835 14.725 11.6668 12.5 11.6668Z",
    fill: "#9978E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person-add.5d7750dd680436444ec7eceaef8427f2.svg";
export { ForwardRef as ReactComponent };